export class SchedulerTaskProgramChecklist {
  public selected: boolean;
  public imported = false;

  constructor(
    public hash?: string,
    public schedulerTaskProgramHash?: string,
    public schedulerTaskProgramIndex?: number,
    public toolHash?: string,
    public toolName?: string,
    public toolHolderHash?: string,
    public toolHolderName?: string,
    public programHash?: string,
    public programReference?: string,
    public programTime?: number,
    public pocket?: number,
    public originalPocket?: number,
    public checked?: boolean,
    public ignorable?: boolean,
    public length?: number,
    public highlighted?: boolean,
    public originallyIgnorable?: boolean,
    public ignorableFixedTool?: boolean,
    public twin?: number,
    public generatedTwin?: boolean,
    public ignorableMasterTaskTool?: boolean,
    public masterTaskHash?: string,
    public masterTaskToolPosition?: number,
    public importedFromTaskHash?: string,
    public hasToolRebuildOption?: boolean,
  ) { }

  clone() {
    const cloned = new SchedulerTaskProgramChecklist(
      this.hash,
      this.schedulerTaskProgramHash,
      this.schedulerTaskProgramIndex,
      this.toolHash,
      this.toolName,
      this.toolHolderHash,
      this.toolHolderName,
      this.programHash,
      this.programReference,
      this.programTime,
      this.pocket,
      this.originalPocket,
      this.checked,
      this.ignorable,
      this.length,
      this.highlighted,
      this.originallyIgnorable,
      this.ignorableFixedTool,
      this.twin,
      this.generatedTwin,
      this.ignorableMasterTaskTool,
      this.masterTaskHash,
      this.masterTaskToolPosition,
      this.importedFromTaskHash,
      this.hasToolRebuildOption,
    );
    cloned.imported = this.imported;

    return cloned;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/scheduler-task-program-checklist.ts